import { Component } from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { Box } from 'reflexbox'

import * as h from 'h'

import { siteTitle, siteTitleShorter } from 'config'

import styles from './styles.scss'

const MenuButton = ({ onClick }) =>
  h.z({ onClick, ...h.ca(styles.menuButton), name: 'toggle navigation menu' },
    h.icon({ name: 'bars' }),
    h.span(h.ca(styles.menuButtonText), 'Menu'))

/**
 * The individual bars of the waves are prone
 * to becoming out of sync. Therefore, whenever
 * the Waves 'show' prop goes false, a timeout
 * is set for 2 seconds (waits for fade animation to end),
 * then the isDestroyed flag is set to true which
 * removes the bars from the DOM so that the
 * next showing will show in-sync bars from the beginning
 */

@observer
class Waves extends Component {
  @observable isDestroyed = true

  componentWillMount () {
    this.isDestroyed = this.props.hide
  }

  componentWillUpdate (nextProps) {
    // See explanation above
    if (this.props.show !== nextProps.show) {
      if (nextProps.show) {
        this.isDestroyed = false
      } else {
        setTimeout(() => {
          // Need to check again,
          // in case something happened within 2s
          if (!this.props.show) {
            this.isDestroyed = true
          }
        }, 2000)
      }
    }
  }

  render () {
    if (this.isDestroyed) {
      return null
    }

    const { show = false, windowWidth = 1000, waveWidth = 10 } = this.props

    const count = Math.ceil(windowWidth / waveWidth)

    const waves = Array(count).fill().map((_, i) => i)
      .map(i => {
        const delay = `${i / 100}s`
        return h.div({
          key: i,
          style: {
            left: i * waveWidth,
            animationDelay: delay,
            WebkitAnimationDelay: delay
          },
          ...h.ca(styles.wave)
        })
      })

    return h.div(h.ca(styles.waves, { [styles.wavesShow]: show }), waves)
  }
}

@observer(['UiStore'])
export default class Header extends Component {
  get pageTitle () {
    return this.props.UiStore.pageTitle
  }

  toggleMenu () {
    this.props.UiStore.toggleMenu()
  }

  render () {
    const { UiStore } = this.props
    const { showProgress, windowWidth } = UiStore

    return h.header(h.ca(styles.header),
      h.h(Waves, { show: showProgress, windowWidth }),
      h.div(h.ca(styles.inner),
        h.h(Box, { auto: true, mx: 2 },
          h.h1(h.ca(styles.logo), h.l({ to: '/' }, siteTitle)),
          h.h1(h.ca(styles.logoSmall), h.l({ to: '/' }, siteTitleShorter))),
        h.h(Box, { mr: 2 },
          h.h2(h.ca(styles.pageTitle), this.pageTitle)),
        h.h(Box, { mr: 2 },
          h.h(MenuButton, { onClick: ::this.toggleMenu }))))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Header/index.js